const itemClass = '.faq__item';
const triggerClass = '.faq__trigger';
const iconClass = '.faq__icon';
const answerClass = '.faq__answer';

window.addEventListener('load', () => {
  const items = document.querySelectorAll(itemClass);

  items.forEach((item) => {
    const trigger = item.querySelector(triggerClass);
    const icon = item.querySelector(iconClass);
    const answer = item.querySelector(answerClass);

    if (!trigger || !answer) {
      return;
    }

    trigger.addEventListener('click', () => {
      const isOpened = trigger.classList.contains('opened');

      trigger.classList.toggle('opened', !isOpened);
      trigger.setAttribute('aria-expanded', String(!isOpened));
      answer.classList.toggle('opened', !isOpened);

      if (icon) {
        icon.classList.toggle('opened', !isOpened);
      }
    });
  });
});
